import { useState } from "react";

const useToggleSelect = () => {
  const [toggle, setToggle] = useState(null);
  const handleToggle = (idx: any) => {
    if (toggle === idx) {
      setToggle(null);
    } else {
      setToggle(idx);
    }
  };

  return { handleToggle, toggle, setToggle };
};

export default useToggleSelect;
